var $ = global.jQuery = global.$;
var ps = require('./ps');
var widgets = require('./widgets');

/**
 * Methods relating to parsing the dom and adding found widgets to registry
 * @exports lib/parser
 * @author Simon Buerger
 */
var parser = {
  /**
   * Parse an element for instances of data-widget
   * @instance
   * @param {string|object} el Either a selector string or a jQuery object
   * @param {function} [callback] Optional callback function
   */
  parse: function(el,callback) {
    var $widgets = $(el).find('[data-widget]');
    $widgets.each(function() {
      var widget = $(this).data('widget');
      widgets.addToRegistry(this, widget);
    });
    if(typeof(callback) === 'function'){
      callback();
    }
    /**
     * Fires once the parse method has completed
     * @event parser:parseComplete
     */
    ps.publish('parser:parseComplete');

    $(el).trigger('parser:parseComplete');
  },
  /**
   * Parse an element as a widget
   * @instance
   * @param {object} $el A jQuery object
   * @param {function} [callback] Optional callback function
   */
  parseOne: function($el,callback) {
    var widget = $el.data('widget');
    widgets.addToRegistry($el, widget);

    if(typeof(callback) === 'function'){
      callback();
    }

    $el.trigger('parser:parseComplete');
  }
};

module.exports = parser;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/lib/parser.js
// module id = 3
// module chunks = 0 1